import { getTenantId } from "../util/common-functions";

export default getTenantId;